import { eventActivityType } from "../../constants/myBlockMonth";


export default function helper(document) {
        const checkElementsInflow = (className: string, calendarContainerRect: DOMRect) => {
            const elements = mapDOMElements(className); 
        
             /* find elements where it's left position is before the calendar but it's right position is within the calendar bounds */
            const inflowingElements = elements.filter(element => Math.round(element.getBoundingClientRect().left) < Math.round(calendarContainerRect.left) && 
                                                      Math.round(element.getBoundingClientRect().right) >= Math.round(calendarContainerRect.left) && 
                                                      Math.round(element.getBoundingClientRect().right) <= Math.round(calendarContainerRect.right))
            inflowingElements.forEach(element => {
                const elementRect = element.getBoundingClientRect();
        
                /* margin left is the calendarContainer's left position -minus the elements left position */
                const marginLeft = Math.abs(calendarContainerRect.left - elementRect.left);
        
                /* apply the margin to the other element */ 
                if(className === 'layover-duration__start-time') formatOverFlowingElement(element.id, 'layoverDurCntr', marginLeft, 'inflow');
                else {
                    if(className === 'layover-duration__short' || className === 'layover-duration__long') formatOverFlowingElement(element.id, 'layoverEndTime', marginLeft, 'inflow');
                    element.style.left =  `${marginLeft}px`;
                    element.style.position = 'relative';
                }
            })
        }
        
        /**
         * Check whether an element overflows out of the calendar
         * @param className of element to check
         * @param calendarContainerRect position of calendar container
         */
         const checkElementOutFlow = (className: string, calendarContainerRect: DOMRect) => {
            const elements = mapDOMElements(className); 
        
            /* find element's where it's right position is greater than the right position of the calendar but it's left position is within the calendar bounds */
            const overflowingElements = elements.filter(element => Math.round(element.getBoundingClientRect().right) > Math.round(calendarContainerRect.right) && 
                                                        Math.round(element.getBoundingClientRect().left) >= Math.round(calendarContainerRect.left) && 
                                                        Math.round(element.getBoundingClientRect().left) <= Math.round(calendarContainerRect.right))
        
            overflowingElements.forEach(element => {
                const elementRect = element.getBoundingClientRect();
        
                /* margin right is the element's right position minus the calendarContainer's right position */
                const marginRight = Math.round(elementRect.right - calendarContainerRect.right); 
        
                /* apply the margin to the other element */
                if(className === 'layover-airport-code') formatOverFlowingElement(element.id, 'layoverAirportCodeCntr', marginRight, 'outflow');
                if(className === 'layover-duration__end-time') formatOverFlowingElement(element.id, 'layoverDurCntr', marginRight, 'outflow');
                else {
                    element.style.right =  `${marginRight}px`;
                    element.style.position = `relative`; 
                }
            })
        }
        
        const checkElementsOverFlow = (calendarContainer: Element) => {
            checkRouteDetailsOverflow('c-pairing-route-details', 'c-pairing-route-details--wrap', calendarContainer.getBoundingClientRect());
        
            checkElementOutFlow('pairing-id', calendarContainer.getBoundingClientRect());
            checkElementOutFlow('other-event__id', calendarContainer.getBoundingClientRect());
            checkElementOutFlow('other-event__check-in', calendarContainer.getBoundingClientRect());
            checkElementOutFlow('layover-duration__end-time', calendarContainer.getBoundingClientRect());
            checkElementOutFlow('layover__hotel__span', calendarContainer.getBoundingClientRect());
            checkElementOutFlow('layover-airport-code', calendarContainer.getBoundingClientRect());
        
            checkElementsInflow('icon-Hotel', calendarContainer.getBoundingClientRect());
            checkElementsInflow('layover-duration__start-time', calendarContainer.getBoundingClientRect());
            checkElementsInflow('layover-duration__short', calendarContainer.getBoundingClientRect());
            checkElementsInflow('layover-duration__long', calendarContainer.getBoundingClientRect());
            checkElementsInflow('layover__hotel__span', calendarContainer.getBoundingClientRect());
        }
        
        const checkElementOverflowResize = (className: string, blockClassName: string, calendarContainerRect: DOMRect) => {
            const elements = mapDOMElements(className); 
            const overflowingElements = elements.filter(element => Math.round(element.getBoundingClientRect().right) > Math.round(calendarContainerRect.right) && 
                                                        Math.round(element.getBoundingClientRect().left) >= Math.round(calendarContainerRect.left) && 
                                                        Math.round(element.getBoundingClientRect().left) <= Math.round(calendarContainerRect.right))
            overflowingElements.forEach(element => {
                const elementRect = element.getBoundingClientRect();
                element.classList.add(blockClassName);
                element.style.width = `${calendarContainerRect.right - elementRect.left}px`
            })
        }
        
        const checkIntersectingElements = (calendarContainer: Element, eventListWithPairingSegments: any[]) => {
            checkIntersectingPairingRouteContainers('c-pairing-route-details', 'c-pairing-route-details--wrap', calendarContainer, calendarContainer.getBoundingClientRect());
            checkIntersectingElementsSameClassNameWithResize('layover__hotel__span', 'layover__hotel--ellipsis');
            checkIntersectingElementsSameClassName('other-event__id', 'other-event__id--ellipsis');
            checkIntersectingElementsSameClassName('other-event__check-in', 'other-event__check-in--ellipsis');
            checkIntersectingElementsSameClassName('other-event__check-out', 'other-event__check-out--ellipsis')
            checkLayoverIntersections(eventListWithPairingSegments);
            //checkIntersectingElementsDifferentClassName('layover-duration__start-time', 'pairing__time pairing__time--check-out', 'layover-duration__start-time--ellipsis')
        }
        
        const checkIntersectingElementsDifferentClassName = (className: string, secondaryClassName: string,  ellipsisClassName: string) => {
            const elements = mapDOMElements(className); 
        
            elements.forEach(element => {
                /* set elementRect to the elements DOMRect object providing information about its size and position relative to the viewport */
                const elementRect = element.getBoundingClientRect();
                const indexSecondUnderscore = element.id.indexOf('__')+2;
                const indexThirdUnderscore = element.id.indexOf('_', element.id.indexOf('0') + 1);
                const id = element.id.slice(indexSecondUnderscore, indexThirdUnderscore);
                const elementEndTime = document.getElementById(`eventEndTime__${id}`);
                if(elementEndTime) {
                    const elRect = elementEndTime.getBoundingClientRect();
        
                    if(Math.round(elRect.top) >= Math.round(elementRect.top)-1 && 
                    Math.round(elRect.top) <= Math.round(elementRect.top)+1 &&
                    Math.round(elRect.left) <= Math.round(elementRect.right)) {
            
                     /* set the element's width to the width between the compareElement's left position and the element's left position */
                     const elementWidth = `${elRect.left - elementRect.left}px`;
            
                     /* set the element's style width to the calculated elementWidth */
                     element.style.width = elementWidth;
            
                     /* if the element does not have the intersectingclassName already applied, apply the interesecting className */
                     if(!element.classList.contains(ellipsisClassName)) element.classList.add(ellipsisClassName);
                    }
                }
            })
        }
        
        /**
         * Determine whether DOM elements in the standard calendar of the same className interesect (based on position)
         * If so, apply the interesectingClassName else remove the interesectingClassName
         * @param className 
         * @param ellipsisClassName 
         */
         const checkIntersectingElementsSameClassName = (className: string, ellipsisClassName: string) => {
            const elements = mapDOMElements(className); 
        
            elements.forEach(element => {
        
                /* set elementRect to the elements DOMRect object providing information about its size and position relative to the viewport */
                const elementRect = element.getBoundingClientRect();
        
                /* set compareElements to an array of the elements minus the current element and elements that come horizontally after (left position >) the element being iterated */
                const compareElements = elements.filter(el => el.id !== element.id && el.getBoundingClientRect().left > elementRect.left);
        
                /* find interesecting elements */
                compareElements.forEach(compareElement => {
                    const compareElementRect = compareElement.getBoundingClientRect();
        
                    /* if the compareElements top position is within +- 1px of the element's top position (windows height of elements are not exact, differ by decimal )
                    and the compareElements left position is less than or equal to the element's right position */
                    if(Math.round(compareElementRect.top) >= Math.round(elementRect.top)-1 && 
                        Math.round(compareElementRect.top) <= Math.round(elementRect.top)+1 &&
                        Math.round(compareElementRect.left) <= Math.round(elementRect.right)) {
        
                        /* set the element's width to the width between the compareElement's left position and the element's left position */
                        const elementWidth = `${compareElementRect.left - elementRect.left}px`;
        
                        /* set the element's style width to the calculated elementWidth */
                        element.style.width = elementWidth;
        
                        /* if the element does not have the intersectingclassName already applied, apply the interesecting className */
                        if(!element.classList.contains(ellipsisClassName)) element.classList.add(ellipsisClassName);
                    }
                }) 
            })
        }
        
        /**
         * Determine whether DOM elements in the strip calendar of the same className interesect (based on position)
         * If so, apply the interesectingClassName else remove the interesectingClassName
         * @param className 
         * @param ellipsisClassName 
         */
         const checkIntersectingElementsSameClassNameWithResize = (className: string, ellipsisClassName: string) => {
            const elements = mapDOMElements(className); 
        
            elements.forEach(element => {
                
                /* set elementWidth to default css width property: auto */
                let elementWidth = 'auto'; 
        
                /* set elementRect to the elements DOMRect object providing information about its size and position relative to the viewport */
                const elementRect = element.getBoundingClientRect();
        
                /* set compareElements to an array of the elements minus the current element and elements that come horizontally after (left position >) the element being iterated */
                const compareElements = elements.filter(el => el.id !== element.id && el.getBoundingClientRect().left > elementRect.left);
        
                /* find interesecting elements */
                compareElements.forEach(compareElement => {
                    const compareElementRect = compareElement.getBoundingClientRect();
        
                    /* if the compareElements top position is within +- 1px of the element's top position (windows height of elements are not exact, differ by decimal )
                    and the compareElements left position is less than or equal to the element's right position */
                    if(Math.round(compareElementRect.top) >= Math.round(elementRect.top)-1 && 
                        Math.round(compareElementRect.top) <= Math.round(elementRect.top)+1 && 
                        Math.round(compareElementRect.left) <= Math.round(elementRect.right)) {
        
                    /* if the element has already interesected a previous compareElement and the elementWidth already contains a px value */
                    if(elementWidth !== 'auto') {
        
                        /* if the current compareElement is closer to the element than the prevous compareElement, set the width to adjust for the ellipsis (RARE scenario) */
                        if(compareElementRect.left - elementRect.left < parseFloat(elementWidth)) {
                        elementWidth = `${compareElementRect.left - elementRect.left}px`;
                        }
                    } else {
                        /* set the element's width to the width between the compareElement's left position and the element's left position, 
                        add the intersecting className so that css will handle the ellipsis after the width is set */
                        elementWidth = `${compareElementRect.left - elementRect.left}px`;
                        element.classList.add(ellipsisClassName);
                    }
                    }
                }) 
        
                /* at the end of the compare elements iteration, set the element's style width to the calculated elementWidth */
                element.style.width = elementWidth;
        
                /* if the element does not interesect with any elements, remove the interesecting className (handle resize from small to large) */
                if(elementWidth === 'auto') element.classList.remove(ellipsisClassName);
            })
        }
        
        const checkIntersectingPairingRouteContainers = (className: string, blockClassName: string, calendarContainer: Element, calendarContainerRect: DOMRect) => {
            let elements = mapDOMElements(className); 
            if(!calendarContainer) return;
            elements = elements.filter(element => Math.round(element.getBoundingClientRect().left) < Math.round(calendarContainerRect.right) || 
                                                    Math.round(element.getBoundingClientRect().right) > Math.round(calendarContainerRect.left))
            elements.forEach(element => {
                let elementWidth = 'auto'; 
                const elementRect = element.getBoundingClientRect();
                const compareElements = elements.filter(el => el.id !== element.id && el.getBoundingClientRect().left > elementRect.left);
                compareElements.forEach(compareElement => {
                    const compareElementRect = compareElement.getBoundingClientRect();
                    if(Math.round(compareElementRect.top) >= Math.round(elementRect.top)-1 && 
                        Math.round(compareElementRect.top) <= Math.round(elementRect.top)+1 && 
                        Math.round(compareElementRect.left) <= Math.round(elementRect.right)) {
        
                        /* if an intersection for the element has already been found */
                        if(elementWidth !== 'auto') {
                            
                            /* if the newer comparison element is closer than the prevous comparison, set the new width to adjust for the ellipsis (RARE scenario) */
                            if(compareElementRect.left - elementRect.left < parseFloat(elementWidth)) elementWidth = `${compareElementRect.left - elementRect.left}px`;
                        
                        } else {
                            elementWidth = `${compareElementRect.left - elementRect.left}px`;
                            element.classList.add(blockClassName);
                        }
                    }
                }) 
                if(!element.hasAttribute('endOverFlow') && elementWidth !== 'auto') element.style.width = elementWidth;
            })
        }
        
        /**
         * Determine if a pairing's route overflows (out) of the calendar's right position bounds
         * @param className 
         * @param blockClassName 
         * @param calendarContainerRect 
         */
         const checkRouteDetailsOverflow = (className: string, blockClassName: string, calendarContainerRect: DOMRect) => {
            const elements = mapDOMElements(className);
        
            /* find element's where it's right position is out of the calendar but it's left position is within the calendar bounds */
            const overflowingElements = elements.filter(el => Math.round(el.getBoundingClientRect().right) > Math.round(calendarContainerRect.right) && 
                                                        Math.round(el.getBoundingClientRect().left) >= Math.round(calendarContainerRect.left) && 
                                                        Math.round(el.getBoundingClientRect().left) <= Math.round(calendarContainerRect.right))
                                                            
            overflowingElements.forEach(element => {
                let elementRect = element.getBoundingClientRect();
        
                /* first check if wrapping the element suffices */
                element.style.width = `${Math.round(calendarContainerRect.right - elementRect.left)}px`;
                element.classList.add(blockClassName);
        
                /* if there are more than 3 rows, route must be shifted to the left */
                if(element.offsetHeight > 36) {
        
                    if(elementRect.width > 125) {
        
                        /* set max width to 125px (YUL 1966 YQB 1967 YUL) */
                        element.style.width = '125px';
            
                        /* get the latest element position */
                        elementRect = element.getBoundingClientRect();
            
                    } else {
                        element.style.width = `${elementRect.width}px`;
                    }
        
                    const overFlowingAmount = Math.round(elementRect.right - calendarContainerRect.right);
        
                    /* add the blockClassName to wrap the element if it doesn't fit within the width's bounds */
                    element.classList.add(blockClassName);
        
                    /* add the overflow amount to shift the element within the calendar vounds */
                    element.style.right = `${overFlowingAmount}px`;
                }
        
                element.style.position = `relative`;
                element.setAttribute('endOverFlow', 'true');
        
                /* hide any details that are more than 3 rows */
                if(element.offsetHeight > 36) {
                    element.style.height ='36px';
                    element.style.overflowY='hidden'
                }
            })
        }
        
        const checkLayoverIntersections = (eventList: any[]) => {
        const pairingEvents = eventList.length && eventList.filter(event => event.activityType === eventActivityType.PAIRING);
        if(pairingEvents && pairingEvents.length > 0) {
            pairingEvents.forEach(event => {
                const layoverCount = event.pairingSegments.filter(segment => !segment.isRoute).length; 
                if(layoverCount > 0) {
                    for(let i=1; i<=layoverCount; i++) checkLayoverTimeEventTimeIntersection(i, event.unique_id, layoverCount);
                } 
            })
        }
        }
        
        const checkLayoverTimeEventTimeIntersection = (i: number, eventUniqueId: string | any, layoverCount: number) => {
            const layoverDurCntr = document.getElementById(`layoverDurCntr__${eventUniqueId}_${i}`);
            const layoverSubCntr = document.getElementById(`layoverSubCntr__${eventUniqueId}_${i}`);
            const layoverStartTime = document.getElementById(`layoverStartTime__${eventUniqueId}_${i}`);
            const eventStartTime = document.getElementById(`eventStartTime__${eventUniqueId}`);
            const eventEndTime = document.getElementById(`eventEndTime__${eventUniqueId}`);
            const hotelName = document.getElementById(`hotel_${eventUniqueId}_${i}`);
            let classAlreadySet = false;
            if(layoverDurCntr && layoverSubCntr && layoverStartTime && hotelName){
                if(i === 1 && eventStartTime) {
                    if(eventStartTime.getBoundingClientRect().right >= layoverStartTime.getBoundingClientRect().left) {
                        classAlreadySet = true;
                        layoverDurCntr.classList.add('c-layover-duration--block');
                        hotelName.classList.add('layover__hotel--next-row');
                    }
                    //else layoverDurCntr.classList.remove('c-layover-duration--block');
                }
                if(i===layoverCount && !classAlreadySet && eventEndTime) {
                    if(layoverSubCntr.getBoundingClientRect().right >= eventEndTime.getBoundingClientRect().left) {
                        layoverDurCntr.classList.add('c-layover-duration--block');
                        hotelName.classList.add('layover__hotel--next-row');
                    }
                    //else layoverDurCntr.classList.remove('c-layover-duration--block')
                }
            }
        }
        
        const checkMinWidth = (className: string) => {
            const elements = mapDOMElements(className); 
            elements.forEach(element => {
                if(element.offsetWidth < 5) element.style.visibility = 'hidden';
            })
        }
        
        /**
         * Handler to appply marginLeft/Right to another element based on the in/out flow of the original element
         * @param elementId 
         * @param element 
         * @param marginRightLeft 
         * @param typeOfOverflow 
         */
         const formatOverFlowingElement = (elementId: string | any, element: string, marginRightLeft: number | any, typeOfOverflow: string) => {
        
            /* find the element to style based on the original elementId */
            const indexOfFirstUnderscore = elementId.indexOf('_');
            const elementIdToFormat = `${element}${elementId.slice(indexOfFirstUnderscore)}`; 
            const elementToFormat = document.getElementById(elementIdToFormat);
        
            if(elementToFormat) {
                if(typeOfOverflow === 'inflow') elementToFormat.style.left = `${marginRightLeft}px`;
                else if(typeOfOverflow === 'outflow') elementToFormat.style.right = `${marginRightLeft}px`;
                elementToFormat.style.position = 'relative';
            }
        }
        
        const hideElements = (className: string, calendarContainerRect: DOMRect) => {
            const elements = mapDOMElements(className); 
            elements.forEach(element => {
                if(Math.round(element.getBoundingClientRect().right) < Math.round(calendarContainerRect.left) || 
                  (Math.round(element.getBoundingClientRect().left) > Math.round(calendarContainerRect.right) && Math.round(element.getBoundingClientRect().right) > Math.round(calendarContainerRect.right))) {
                    element.style.display = 'none';
                };
            })  
        }
        
        /**
         * @param className 
         * @returns new array of all DOM elements for the given className 
         */
        const mapDOMElements = (className: string) => {
            const DOM_ELEMENTS = document.getElementsByClassName(className);
            let elements = [] as any;
            for(let i=0; i<DOM_ELEMENTS.length; i++) elements.push(DOM_ELEMENTS[i]);
            return elements; 
        }
    
        return {
            mapDOMElements,
            checkElementsInflow,
            checkElementOutFlow,
            checkElementsOverFlow,
            checkElementOverflowResize,
            checkIntersectingElements,
            checkIntersectingElementsDifferentClassName,
            checkIntersectingElementsSameClassName,
            checkIntersectingElementsSameClassNameWithResize,
            checkIntersectingPairingRouteContainers,
            checkRouteDetailsOverflow,
            checkLayoverIntersections,
            checkLayoverTimeEventTimeIntersection,
            checkMinWidth,
            hideElements
        }    
}